import { Box, Stack, Typography } from "@mui/material";
import { SmallLineChart } from "components/Charts";
import { FC } from "react";

export interface LineChartData {
  date: string;
  value: number;
}

interface RequirementFeedbackStatsPanelCompactedProps {
  totalFeedbacks: number;
  currentRate: number;
  data: LineChartData[];
  onClickDot: (data: any) => void;
}

export const RequirementFeedbackStatsPanelCompacted: FC<
  RequirementFeedbackStatsPanelCompactedProps
> = ({ totalFeedbacks, currentRate, data, onClickDot }) => {
  return (
    <Box>
      {/* Charts Section */}
      {/* Line Chart */}

      <Typography variant="body2" fontWeight={600} sx={{ mb: 2 }}>
        Score Progress
      </Typography>
      <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }} mb={2}>
        <SmallLineChart
          data={data}
          height={120}
          onClickDot={() => {
            onClickDot(data);
          }}
        />
      </Box>

      {/* Stats Section */}

      <Stack direction="column" spacing={1}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2" fontWeight={600}>
            Total Feedback
          </Typography>
          <Typography variant="body2" component="p">
            {totalFeedbacks}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2" fontWeight={600}>
            Current Level
          </Typography>
          <Typography variant="body2" component="p">
            {currentRate}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
